import { faker } from '@faker-js/faker';
import { generateFromEnum } from '@ingenico/api-sdk-core/mocks';
import type {
  SoftwareVersionArtifactResourceReadV2Api,
  TemplateResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { enumArtifactComponentType, enumArtifactType } from '@ingenico/api-sdk-device-management-private-v2';

export function generateTemplateResourceReadV2Api(
  override?: Partial<TemplateResourceReadV2Api>,
): TemplateResourceReadV2Api {
  return {
    checksum: faker.string.uuid(),
    componentType: generateFromEnum(enumArtifactComponentType),
    createdBy: faker.string.uuid(),
    creationDate: faker.date.past(),
    description: faker.finance.transactionDescription(),
    extension: faker.system.fileExt(),
    fileName: faker.system.fileName(),
    id: faker.string.uuid(),
    mimeType: faker.system.mimeType(),
    name: faker.lorem.word(),
    size: faker.number.int({ min: 1000, max: 10_000 }),
    targetLocation: faker.system.filePath(),
    templateFileId: faker.string.uuid(),
    templateFileName: faker.system.fileName(),
    templateFileVersion: faker.system.semver(),
    type: generateFromEnum(enumArtifactType),
    ...override,
  };
}

export function generateArtifactReadV2Api(): SoftwareVersionArtifactResourceReadV2Api {
  return {
    checksum: faker.string.hexadecimal({ length: 32, casing: 'lower' }),
    componentType: 'APPLICATION',
    createdBy: faker.string.uuid(),
    creationDate: faker.date.past(),
    extension: faker.system.fileExt(),
    fileName: `${faker.system.fileName()}.zip`,
    id: faker.string.uuid(),
    mimeType: 'application/zip',
    size: faker.number.int({ min: 10_000, max: 500_000 }),
    type: 'SW_PACKAGE',
    order: 0,
    targetLocation: faker.system.filePath(),
  };
}
